import { container } from "assets/jss/material-kit-react.js";
import theme from "theme";

const footerStyle = {
  root: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      justifyContent: "center",
    },
  },
  block: {
    color: "inherit",
    padding: "0.9375rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0.3rem 0.9375rem",
    },
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "flex",
    alignItems: "center",
    "&,&:hover,&:focus": {
      color: theme.palette.common.white,
    },
  },
  footerBlock: {
    color: "inherit",
    padding: "0.9375rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0.3rem 0.9375rem",
    },
    fontWeight: "500",
    fontSize: "12px",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "flex",
    alignItems: "center",
    "&,&:hover,&:focus": {
      color: theme.palette.common.white,
    },
  },
  sectionTitle: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    textDecoration: "none",
    position: "relative",
    display: "flex",
    alignItems: "center",
    "&,&:hover,&:focus": {
      color: theme.palette.common.white,
    },
  },
  left: {
    float: "left!important",
    display: "block",
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right!important",
  },
  footer: {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    paddingTop: "40px",
    paddingBottom: "20px",
    alignItem: "center",
    textAlign: "center",
    zIndex: "2",
    position: "relative",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  a: {
    color: theme.palette.common.white,
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": {
      color: theme.palette.common.white,
    },
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FFFFFF",
    },
  },
  container,
  list: {
    marginBottom: "-20px",
    padding: "0",
    marginTop: "0",
  },
  inlineBlock: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
    },
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
  rightBlock: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      textAlign: "center",
    },
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
  socialBlock: {
    display: "inline-block",
    width: "auto",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "left",
      float: "left",
      width: "auto",
    },
    padding: "0px",
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px",
  },
  socialIcons: {
    fontSize: "28px",
    marginRight: "8px",
    color: "#DDDDDD",
  },
  socialText: {
    fontSize: "14px",
    color: "#DDDDDD",
  },
  mobileList: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px",
    }
  },
};
export default footerStyle;
